import Vue from 'vue';
import { defineNuxtPlugin } from '@nuxtjs/composition-api';
import type { ModalPlugin } from './types';

const DEFAULT_TRANSITION = 'fade';

export default defineNuxtPlugin((ctx, inject) => {
  const emitter = new Vue();

  const $modal = {
    show(name, params) {
      emitter.$emit('toggle', name, true, params);
      this.current = name;
      return this;
    },

    hide(name, params) {
      emitter.$emit('toggle', name || this.current, false, params);
      if (this.current === name) this.current = null;
      return this;
    },

    toggle(name, params) {
      emitter.$emit('toggle', name, undefined, params);
      // FIXME: there is the case when we override the prev modal, but not hide it
      //        we should use array for modals
      if (this.current === name) {
        this.current = null;
      } else {
        this.current = name;
      }
      return this;
    },

    showWithRoute(modal, queryAttrs = {}) {
      const {
        app: { $utils, $constants },
        route,
      } = ctx;
      // @ts-ignore
      const modalName = modal.custom || $constants.dynamicModals[modal] || modal;

      // @ts-ignore
      $utils.routePushWithQuery(route, { query: { dynamic_modal: modalName, ...queryAttrs } });
      this.current = modalName;
      return this;
    },
    emitter,
    current: null,
    // Quick workaround to change a transition of modal
    // It's reactive, because we need to watch it for Portal to change the transition
    // TODO: make it more flexible (e.g add a transition to the modal itself)
    options: Vue.observable({
      transition: DEFAULT_TRANSITION,
    }),
  } as ModalPlugin;

  inject('modal', $modal);
});
